/**
 * App-level wrapper around the package's useVisualizationMetadata.
 * Injects servicesClass from URL params so callers don't need to.
 */
import { useVisualizationMetadata as useVisualizationMetadataBase } from "@atlas-int/data";
import { useExploreParams } from "../paramSchemas";

export const useVisualizationMetadata = () => {
  const [{ servicesClass }] = useExploreParams();
  return useVisualizationMetadataBase({ servicesClass });
};
